export default __webpack_public_path__ + "static/media/CL06.393a3bdb.mp3";